import { useTranslation } from "react-i18next";
import NavBreadcrum from "components/NavBreadcrum";
import MenuButtons from "components/MenuButtons";
import navs from "./navs";

const MainDeviceConfiguration = () => {

    const [t] = useTranslation("routes")
    const bread = [
        { name: t("labels.device-configuration"), current: true }
    ]

    return (
        <>
            <NavBreadcrum navs={navs} bread={bread} />
            <div className="row">
                <div className="col-12">
                    <MenuButtons navs={navs} />
                </div>
            </div>
        </>
    )
}
export default MainDeviceConfiguration;